$(document).ready(function () {
  //Take to shooping cart
  if ($('#salesBanner').length) {
    let salesBannerHeight = Math.floor($('#salesBanner').height());

    if ($('#salesBanner').hasClass('isSticky')) {
      $('#salesBanner, .btn:not(.cta):not(.play), .bannerSpecial, #promoBanner').on('click', function (event) {
        if ($("#topSection").length) {
          $('html, body').animate({
            scrollTop: $("#topSection").offset().top - salesBannerHeight
          }, 1000);
        
        } else if ($('#productBanner').lenth) {
          $('html, body').animate({
            scrollTop: $("#productBanner").offset().top - salesBannerHeight
          }, 1000);
        }
      });
    } else {
      $('#salesBanner, .btn:not(.cta):not(.play), .bannerSpecial, #promoBanner').on('click', function (event) {
        if ($("#topSection").length) {
          $('html, body').animate({
            scrollTop: $("#topSection").offset().top
          }, 1000);

        } else if ($('#productBanner').lenth) {
          $('html, body').animate({
            scrollTop: $("#productBanner").offset().top
          }, 1000);
        }
      });
    }

  } else {
    $('.btn:not(.cta):not(.play), .bannerSpecial, #promoBanner').on('click', function (event) {
      if ($('body').hasClass('show-promoBanner') && !$('body').hasClass('show-promoBanner--club')) {
        $('html, body').animate({
          scrollTop: $("#promoBannerAnchor").offset().top
        }, 1000);

      } else if ($("#topSection").length) {
        $('html, body').animate({
          scrollTop: $("#topSection").offset().top
        }, 1000);
        
      } else if ($("#productBanner").length) {
        $('html, body').animate({
          scrollTop: $("#productBanner").offset().top
        }, 1000);
      }
    });
  }

  /**
   * Cart Toggle Section Modes and updates each section 
   */
  function activeProduct() {
    let thisProduct = $(this);

    let amount = thisProduct.attr('data-units'),
      price = 'data-price',
      link = 'data-link',
      ship = 'data-shipping',
      retail = 'data-retail',
      sale = '';

    let selectedProductAmount = $('#cartToggle').find(`[data-units='${amount}']`);

    /**
     * Specific vars for Subscription Mode
     */
    let subscriptionMode = {
      wrap: $('#subscribeSection'),
      prod: $('#subscribeSection').find(`[data-units='${amount}']`),
      param: $('#subscribeSection').find('.btn').attr('data-param')
    }

    /**
     * Specific vars for Normal Mode
     */
    let regularMode = {
      wrap: $('#regularSection'),
      prod: $('#regularSection').find(`[data-units='${amount}']`),
      param: $('#regularSection').find('.btn').attr('data-param')
    }
    /**
     * Under Morning Sale 
     */
    if ($('body').hasClass('show-promoBanner')) {
      sale = '-sale';
    }

    /**
     * Product buttons states
     */
    $('.cart__product').removeClass('active');
    selectedProductAmount.addClass('active');

    /**
     * Controls Product Images based on selection
     */
    $('#orderNow').removeClass(function (index, className) {
      return (className.match(/(^|\s)cart--unit\S+/g) || []).join(' ');
    }).addClass('cart--unit' + amount);

    const carts = [subscriptionMode, regularMode];

    for (const cart of carts) {
      let savingsVal = cart['prod'].attr(retail) - cart['prod'].attr(price + sale);

      cart['wrap'].find('.price__value').html('$' + cart['prod'].attr(price + sale));
      cart['wrap'].find('.retail__value').html('$' + cart['prod'].attr(retail));
      cart['wrap'].find('.saving__value').html('$' + parseFloat(savingsVal).toFixed(2));

      cart['wrap'].find('.shipping__value').html(cart['prod'].attr(ship));

      cart['wrap'].find('.btn').attr('href', (cart['prod'].attr(link + sale) + cart['param']));
    }
  };

  /**
   * Subscription Option UI and Behaviour 
   */
  $('.subscribe-wrap__option').on('click', function () {
    $('.subscribe-wrap').toggleClass('active');

    if ($('#cartToggle').attr('data-check') === 'un-subscribe') {
      $('#cartToggle').attr('data-check', 'subscribe');
      $('body').addClass('show-promoBanner--club');

    } else {
      $('#cartToggle').attr('data-check', 'un-subscribe');
      $('body').removeClass('show-promoBanner--club');

    }

    //- reset subscription disclaimer checkbox
    if ($('#disclaimerTrigger').hasClass('checked') && !$('#cartCTASubscribe').hasClass('disabled')) {
      $('#disclaimerTrigger').removeClass('checked');
      $('#cartCTASubscribe').addClass('disabled');
      $('.purchase-box__checkbox').attr('data-checkbox', false);
    }

    if ($('body').hasClass('show-promoBanner') && $("#topSection").length) {
      let promoBannerHeight = Math.floor($('#promoBanner').height());

      $('html, body').animate({
        scrollTop: $("#topSection").offset().top - promoBannerHeight
      }, 1000);

    } else {
      $('html, body').animate({
        scrollTop: $("#topSection").offset().top
      }, 1000);
    }
  })

  /**
   * Disclaimer Checkbox and Button disabled
   */
  $('#disclaimerTrigger').on('click', function (e) {
    e.preventDefault();

    if (!$(this).hasClass('checked') && $('#cartCTASubscribe').hasClass('disabled')) {
      $(this).addClass('checked');
      $('#cartCTASubscribe').removeClass('disabled');
      $('.purchase-box__checkbox').attr('data-checkbox', true);

    } else {
      $(this).removeClass('checked');
      $('#cartCTASubscribe').addClass('disabled');
      $('.purchase-box__checkbox').attr('data-checkbox', false);
    }
  });

  $('.cart__product').on('click', activeProduct);
  $('.cart__product.active').trigger("click");

  //- Other Sections
  $('.tabs .items').slick({
    speed: 300,
    centerMode: false,
    adaptiveHeight: true,
    dots: true,
    appendDots: $(".tabs .nav"),
    customPaging: function (slick, index) {
      var title = slick.$slides.eq(index).find('.item').attr('data-title');
      return ' <div class="item">' + title + '</div>'
    }
  });

  if($('#reviewsComment').length) {
    $('#reviewsComment').slick({
      slidesToShow: 1,
      arrows: true,
      dots: true,
      speed: 300,
      autoplay: true,
      autoplaySpeed: 3000,
      centerMode: false
    });
  }

  //- Set current Year to footer Copyright
  let thisDate = new Date();
  $('#year').html(thisDate.getFullYear());
});
